
import { IContact, IGroup, IPaginate, ISenderID } from '@/types/types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Field is required',
});

type RecipientValue = number | { id: number; phone?: number | string };

@Component({
  name: 'CreateEventForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class CreateEventForm extends Vue {
  @Prop({ type: String, default: null }) minWidth!: string | null;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: Array, required: true }) options!: string[];
  @Prop({ type: Number, required: true }) selectedOption!: number;
  @Prop({ type: Array, default: () => [] }) smsIDList!: Array<
    ISenderID & { uuid: string; id: number; slug: string }
  >;
  @Prop({ type: String, required: true }) senderId!: string;
  @Prop({ type: String, required: true }) date!: string;
  @Prop({ type: String, required: true }) today!: string;
  @Prop({ type: String, required: true }) selectedTime!: string;
  @Prop({ type: Array, default: () => [] }) times!: string[];
  @Prop({ type: Array, default: () => [] }) groups!: ReadonlyArray<IGroup>;
  @Prop({ type: Array, default: () => [] }) contacts!: ReadonlyArray<IContact>;
  @Prop({ type: Object, required: true }) paginate!: Pick<
    IPaginate,
    'page' | 'total' | 'itemsPerPage' | 'pages'
  > & { limit: number };
  @Prop({ type: Array, default: () => [] })
  selectedGroupsOrContacts!: RecipientValue[];
  @Prop({ type: Boolean, required: true }) receivers!: boolean;
  @Prop({ type: String, required: true }) description!: string;
  @Prop({ type: Boolean, default: false }) isLoading!: boolean;

  menu = false;

  get recipientItems(): ReadonlyArray<IGroup> | ReadonlyArray<IContact> {
    return this.selectedOption === 0 ? this.groups : this.contacts;
  }

  updateName(value: string): void {
    this.$emit('update:name', value);
  }

  updateOption(value: number): void {
    this.$emit('update:selectedOption', value);
  }

  updateSenderId(value: string): void {
    this.$emit('update:senderId', value);
  }

  updateDate(value: string): void {
    this.menu = false;
    this.$emit('update:date', value);
  }

  updateTime(value: string): void {
    this.$emit('update:selectedTime', value);
  }

  updateRecipients(value: RecipientValue[]): void {
    this.$emit('update:selectedGroupsOrContacts', value);
  }

  updateReceivers(value: boolean): void {
    this.$emit('update:receivers', value);
  }

  updateDescription(value: string): void {
    this.$emit('update:description', value);
  }

  loadMoreContacts(): void {
    this.$emit('load-more-contacts');
  }

  remove(): void {
    this.$emit('remove');
  }

  submit(): void {
    this.$emit('submit');
  }
}
